export default "__VITE_ASSET__CcHHVgzz__"